import api from '@/api/client';
import { ENDPOINTS } from '@/api/endpoints';
import type { CreatePrintRequestPayload, PrintRequestDto } from '@/types';
import type { ApiResponse } from '@/types/common.types';

export const printRequestService = {
  create: (payload: CreatePrintRequestPayload) => {
    const formData = new FormData();
    formData.append('file', payload.file);
    formData.append('original_filename', payload.original_filename);
    formData.append('vendor', String(payload.vendor));
    formData.append('kiosk', String(payload.kiosk)); 

    if (payload.user_name) formData.append('user_name', payload.user_name);
    if (payload.user_phone) formData.append('user_phone', payload.user_phone);
    if (payload.user_email) formData.append('user_email', payload.user_email);
    if (payload.total_pages !== undefined) formData.append('total_pages', String(payload.total_pages));
    if (payload.page_range) formData.append('page_range', payload.page_range);
    if (payload.copies !== undefined) formData.append('copies', String(payload.copies));
    if (payload.is_color !== undefined) formData.append('is_color', String(payload.is_color));
    if (payload.is_duplex !== undefined) formData.append('is_duplex', String(payload.is_duplex));
    if (payload.paper_size) formData.append('paper_size', payload.paper_size);
    if (payload.orientation) formData.append('orientation', payload.orientation);
    if (payload.total_amount !== undefined)
         formData.append('total_amount', payload.total_amount.toFixed(2));
        
    return api.post<ApiResponse<PrintRequestDto>>(ENDPOINTS.printRequests.create, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};